import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import dayjs from "dayjs";
import { t } from "i18next";
import { useDispatch } from "react-redux";
import { CrossIcon } from "../../../../../../../assets/customIcons";
import { MuiRightDrawer } from "../../../../../../../builderPackage/components";
import { DynamicFormBuilderContainer } from "../../../../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { APISchema, LOCAL_STORAGE_KEYS } from "../../../../../../../constants";
import { setState } from "../../../../../../../redux/crudSlice";
import { faintGray } from "../../../../../../../theme/palette";
import { systemColor } from "../../../../../../../theme/systemColor";
import { getLocalStorageItem } from "../../../../../../../utils/storageHelper";
import { getWarehouseListAPICall } from "../../../../../../journalVoucher/services/apiCalls";
import { statusListGet } from "../../../../../../stockAdjustment/apiCall";
import { transporterListAPICall } from "../../interWarehouseStockTransferRequisition/services/apiCall";
export var InterWarehouseInwardFilter = function (props) {
    var _getLocalStorageItem;
    var isFilterOpen = props.isFilterOpen, setFilterOpen = props.setFilterOpen;
    var dispatch = useDispatch();
    var UserOrganization = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.Branches[0];
    var handleApplyClick = function (event, values) {
        var req = _objectSpread({
            SourceTenantId: UserOrganization === null || UserOrganization === void 0 ? void 0 : UserOrganization.OrganizationId,
            SourceParentTenantId: UserOrganization === null || UserOrganization === void 0 ? void 0 : UserOrganization.ParentOrganizationId
        }, values);
        dispatch(setState({
            key: "filterValue",
            value: {
                data: req,
                success: true
            }
        }));
        setFilterOpen(false);
    };
    var getStatusListBtSystemName = function (params) { return statusListGet(_objectSpread(_objectSpread({}, params), {}, {
        request: _objectSpread(_objectSpread({}, params.request), {}, {
            SystemName: APISchema.StockTransferRequisition
        })
    })); };
    var getWarehouseListByTentantId = function (params) { return getWarehouseListAPICall(_objectSpread(_objectSpread({}, params), {}, {
        request: {
            TenantId: UserOrganization === null || UserOrganization === void 0 ? void 0 : UserOrganization.OrganizationId
        }
    })); };
    var getTransporterListByParentOrganizationId = function (params) { return transporterListAPICall(_objectSpread(_objectSpread({}, params), {}, {
        request: {
            ParentOrganizationId: UserOrganization === null || UserOrganization === void 0 ? void 0 : UserOrganization.ParentOrganizationId
        }
    })); };
    var handleRangeChange = function (range) {
        var currentDate = new Date();
        switch (range) {
            case 'Weekly':
                var nextWeekDate = new Date(currentDate.getTime() + 7 * 24 * 60 * 60 * 1000);
                return nextWeekDate;
            case 'Monthly':
                var nextMonthDate = new Date(currentDate.getTime() + 30 * 24 * 60 * 60 * 1000);
                return nextMonthDate;
            case 'Yearly':
                var nextYearDate = new Date(currentDate.getTime() + 365 * 24 * 60 * 60 * 1000);
                return nextYearDate;
            case 'Custom':
                return 'Custom';
            default:
                return null;
        }
    };
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: 'Header',
            label: '',
            elements: [{
                    type: FormItemTypes.Typography,
                    name: 'HeaderText',
                    label: t('Filters'),
                    children: t("Apply filters to table data."),
                    value: null,
                    columnSize: true,
                    variant: "h4",
                    color: 'secondary',
                    labelTypographyProps: {
                        variant: 'h3',
                        color: systemColor.black
                    }
                }, {
                    type: FormItemTypes.IconButton,
                    name: 'HeaderCloseIcon',
                    label: '',
                    children: /*#__PURE__*/ React.createElement(CrossIcon, {
                        sx: {
                            fontSize: '10px'
                        },
                        color: "secondary"
                    }),
                    value: null,
                    columnSize: 1.5,
                    size: 'large',
                    onClick: function () { return setFilterOpen(false); }
                }],
            value: null,
            columnSize: 12
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'FormContainer',
            label: '',
            value: null,
            columnSize: 12,
            sx: {
                marginBottom: '20px',
                flexGrow: 1,
                overflowY: 'auto',
                padding: '16px',
                paddingBottom: 6
            },
            spacing: 1.5,
            elements: [{
                    type: FormItemTypes.SearchSelect,
                    name: 'FilterName',
                    label: '',
                    displayExpr: "Name",
                    placeholder: "Select saved filter",
                    valueExpr: "id",
                    value: null,
                    columnSize: 12
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'SourceWarehouseId',
                    label: 'Source Warehouse',
                    displayExpr: "DisplayName",
                    getListData: getWarehouseListByTentantId,
                    valueExpr: "id",
                    value: null,
                    columnSize: 12
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'DestinationWarehouseId',
                    label: 'Destination Warehouse',
                    displayExpr: "DisplayName",
                    getListData: getWarehouseListByTentantId,
                    valueExpr: "id",
                    value: null,
                    columnSize: 12
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'TransporterId',
                    label: 'Transporter',
                    displayExpr: "Name",
                    getListData: getTransporterListByParentOrganizationId,
                    valueExpr: "id",
                    value: null,
                    columnSize: 12
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'DateRange',
                    label: 'Date range',
                    options: [{
                            id: 1,
                            name: 'Weekly'
                        }, {
                            id: 2,
                            name: 'Monthly'
                        }, {
                            id: 3,
                            name: 'Yearly'
                        }, {
                            id: 4,
                            name: 'Custom'
                        }],
                    setFormState: function (formValues, currValue) {
                        if (!((currValue === null || currValue === void 0 ? void 0 : currValue.name) == 'Custom')) {
                            var currentDate = new Date();
                            var date = handleRangeChange(currValue === null || currValue === void 0 ? void 0 : currValue.name);
                            return _objectSpread(_objectSpread({}, formValues), {}, {
                                FromDate: currentDate,
                                ToDate: date
                            });
                        }
                        else {
                            return _objectSpread(_objectSpread({}, formValues), {}, {
                                FromDate: null,
                                ToDate: null
                            });
                        }
                    },
                    valueExpr: "id",
                    displayExpr: 'name',
                    value: null,
                    columnSize: 12
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: 'SelectSpareIssueDate',
                    label: 'Spare Issue Data',
                    value: null,
                    columnSize: 12,
                    spacing: 0.5,
                    setFieldProps: function (formValues, currValue) {
                        return {
                            type: this.type,
                            display: (formValues === null || formValues === void 0 ? void 0 : formValues.DateRange) == 4 ? 'flex' : 'none'
                        };
                    },
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: 'SelectSpareIssueDateTypography',
                            label: 'Date',
                            value: null,
                            columnSize: 12
                        }, {
                            type: FormItemTypes.DatePicker,
                            name: 'FromDate',
                            label: '',
                            placeholder: "From",
                            value: null,
                            columnSize: 6,
                            setFormState: function () { return ({
                                ToDate: null
                            }); }
                        }, {
                            type: FormItemTypes.DatePicker,
                            name: 'ToDate',
                            label: '',
                            placeholder: "To",
                            value: null,
                            setFieldProps: function (formValues) {
                                return {
                                    type: this.type,
                                    minDate: dayjs(formValues === null || formValues === void 0 ? void 0 : formValues.FromDate)
                                };
                            },
                            columnSize: 6
                        }]
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'Status',
                    label: 'Status',
                    multiple: true,
                    getListData: getStatusListBtSystemName,
                    valueExpr: "id",
                    value: null,
                    columnSize: 12
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'ButtonContainer',
            label: '',
            value: null,
            spacing: 0,
            sx: {
                bottom: 0,
                justifyContent: 'space-between',
                backgroundColor: 'white',
                width: {
                    xs: '100%',
                    sm: '400px'
                },
                position: 'fixed',
                right: 0,
                zIndex: 1000,
                paddingBottom: '16px',
                borderTop: "1px solid ".concat(faintGray)
            },
            elements: [{
                    type: FormItemTypes.Button,
                    name: 'Save Filter',
                    label: '',
                    children: 'Save Filter',
                    value: null,
                    columnSize: 4,
                    disabled: true
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: 'saveButton',
                    label: '',
                    value: null,
                    columnSize: 8,
                    spacing: 1,
                    elements: [{
                            type: FormItemTypes.Button,
                            name: 'discard',
                            label: '',
                            children: 'Reset Filters',
                            value: null,
                            id: "discard",
                            columnSize: 7,
                            onClick: function () {
                                return 'reset';
                            },
                            variant: 'outlined'
                            // sx: {
                            //     border: `1px solid ${faintGray}`,
                            //     marginLeft: '2px',
                            // }
                        }, {
                            type: FormItemTypes.Button,
                            name: 'Apply',
                            label: '',
                            children: 'Apply',
                            value: null,
                            columnSize: 2,
                            variant: 'contained',
                            onClick: handleApplyClick
                        }]
                }],
            columnSize: 12
        }];
    return /*#__PURE__*/ React.createElement(MuiRightDrawer, {
        id: "filter-drawer",
        anchor: "right",
        openDrawer: isFilterOpen,
        onClose: function () { return setFilterOpen(false); },
        sx: {
            width: {
                xs: '100%',
                sm: "400px"
            }
        }
    }, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        formProps: {
            p: 1.5,
            mt: {
                xs: 0,
                md: 8
            }
        },
        getKey: "filterValue",
        mode: "edit"
    }));
};
